import React from 'react';
import { ReceivingListTemplate } from 'themes/modules/receiving/pages';
import { ReceivingListViewStore } from 'modules/receiving/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new ReceivingListViewStore(rootStore), 'receivingListViewStore')
class ReceivingList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<ReceivingListTemplate
				{...this.props}
				change={this.props.receivingListViewStore.change}
				actions={this.props.receivingListViewStore}
				showActions={this.props.receivingListViewStore.showActions}
				viewStore={this.props.receivingListViewStore}
			/>
		);
	}
}

export default ReceivingList;



// WEBPACK FOOTER //
// ./src/modules/receiving/pages/ReceivingList.jsx